import styled from "styled-components";
import { ButtonStyleProps } from "./CategoryFilters.interface";

export const Container = styled.div`
  display: flex;
  overflow: auto hidden;
  gap: ${({ theme }) => theme.spacing * 3}px;
  align-items: center;
  scroll-snap-type: x mandatory;
  flex-wrap: nowrap;
  ::-webkit-scrollbar {
    display: none;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    position: absolute;
    z-index: 2000;
    top: 28px;
    left: 16px;
    flex-wrap: wrap;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100vw;
    &.container {
      width: 100%;
    }
  }
`;

export const Button = styled.button<ButtonStyleProps>`
  border-radius: ${({ theme }) => theme.radius}px;
  padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px;
  background-color: ${({ theme, active }) => active ? theme.colors.primary[50] : theme.colors.gray[50]};
  color: ${({ theme, active }) => active ? theme.colors.primary[500] : theme.colors.gray[900]};
  scroll-snap-stop: always;
  scroll-snap-align: center;
  white-space: nowrap;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  outline: none;
  border: none;
  box-shadow: ${({ theme }) => theme.boxShadow};
`;
